import React, { ReactNode } from 'react';
import { ModalsKeys } from 'global';
import { CreateUpdateInvoiceModal } from 'modules/invoice';
import { DocuSignDialog } from 'modules/integrations/docuSign';
import { CreateProposalProductDialog } from 'modules/proposals';
import { CreatePartnerAccountDialog } from 'modules/aftermarket';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { FinanceProgramModal, PreviewFinanceProgramModal } from 'modules/financeProgram';
import { ActivityDialog, CallActivityDialog, NoteActivityDialog } from 'modules/dealActivity';
import { UploadImagesForExistingEquipmentDialog, PreviewExistingImagesDialog } from 'modules/equipment';
import { CalculatedRevenueModal } from './tabs/revenue/CalculatedRevenueModal';

import PageOpportunityDetails from './PageOpportunityDetails';

const modalsWithKeys: Partial<Record<ModalsKeys, ReactNode>> = {
  [ModalsKeys.DocuSignDialog]: <DocuSignDialog />,
  [ModalsKeys.ActivityDialog]: <ActivityDialog />,
  [ModalsKeys.FinanceForm]: <FinanceProgramModal />,
  [ModalsKeys.CallActivityDialog]: <CallActivityDialog />,
  [ModalsKeys.NoteActivityDialog]: <NoteActivityDialog />,
  [ModalsKeys.PreviewFinanceForm]: <PreviewFinanceProgramModal />,
  [ModalsKeys.CreateUpdateInvoiceDialog]: <CreateUpdateInvoiceModal />,
  [ModalsKeys.AftermarketCreatePartnerDialog]: <CreatePartnerAccountDialog />,
  [ModalsKeys.ProposalCreateProductDialog]: <CreateProposalProductDialog />,
  [ModalsKeys.PreviewExistingEquipmentImagesDialog]: <PreviewExistingImagesDialog />,
  [ModalsKeys.UploadImagesForExistingEquipmentDialog]: <UploadImagesForExistingEquipmentDialog />,
  [ModalsKeys.CalculatedRevenueDialog]: <CalculatedRevenueModal />,
};

export const PageOpportunityDetailsContainer = () => (
  <PageContainer modals={modalsWithKeys} title="Opportunity Details">
    <PageOpportunityDetails />
  </PageContainer>
);
